<template>
  <div>
    <small class="text-secondary"> {{ name }} <span class="text-danger" v-if="isRequired">*</span> </small>
    <input type="file" id="file" ref="file" @input="add" accept="image/*" class="form-control" :class="{ 'is-invalid': error }"/>
    <message-error :code="errorCode" :hasError="error"/>
    <small class="text-danger" v-if="errorImgSize">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      La taille du fichier dépasse la limite maximale (10Mo)
    </small>
  </div>
</template>

<script>
import MessageError from '@/core/components/MessageError.vue'

export default {
  name: 'FileField',
  components: { MessageError },
  props:{
    isRequired:{ type: Boolean },
    name:{ type: String },
    errorCode: { type: String },
    error: { type: Boolean }
  },
  data(){
    return {
      imageFile: null,
      input: null,
      isImageUploading: false,
      errorImgSize: false
    }
  },
  methods:{
    add(event){
      if(event instanceof Event){
        var imgSize = this.$refs.file.files[0].size
        var nbFiles = event.target.files.length
        if(imgSize < 10485760 && nbFiles > 0){
          this.errorImgSize = false
        }else {
          this.errorImgSize = true
        }
        this.$emit("input", this.$refs.file.files[0]);
      }
    }
  }
}
</script>

<style scoped>
input {
  border-radius: 0 !important;
}
</style>
